"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for subscription service
 * @param {string} message the validation message
 */
class CustomerSubscriptionDoesntRequirePaymentError extends client_library_1.ExtendableError {
    constructor() {
        super('CustomerSubscriptionDoesntRequirePayment');
    }
}
exports.default = CustomerSubscriptionDoesntRequirePaymentError;
//# sourceMappingURL=CustomerSubscriptionDoesntRequirePaymentError.js.map